import { createTheme as createMuiTheme } from '@mui/material';
import { Settings } from '../contexts/SettingsContext';

export const createTheme = (settings: Settings) => {
  return createMuiTheme({
    typography: {
      fontFamily: '"apple-system", "BlinkMacSystemFont", "Segoe UI", "Roboto", "Helvetica", sans-serif',
      fontSize: 12,
      htmlFontSize: 15,
      h1: {
        fontWeight: 700,
        fontSize: '2rem',
      },
      h2: {
        fontWeight: 600,
        fontSize: '1.6rem',
      },
      h3: {
        fontWeight: 600,
        fontSize: '1.4rem',
      },
      h4: {
        fontWeight: 600,
        fontSize: '1.2rem',
      },
      h5: {
        fontWeight: 600,
        fontSize: '1rem',
      },
      h6: {
        fontWeight: 600,
        fontSize: '0.85rem',
      },
      body1: {
        fontSize: '0.9rem',
        lineHeight: 1.5,
      },
      body2: {
        fontSize: '0.8rem',
        lineHeight: 1.45,
      },
      subtitle1: {
        fontSize: '0.85rem',
        fontWeight: 500,
      },
      subtitle2: {
        fontSize: '0.75rem',
        fontWeight: 500,
      },
      button: {
        textTransform: 'none',
        fontWeight: 500,
        fontSize: '0.9rem',
      },
      caption: {
        fontSize: '0.7rem',
      },
    },
    palette: {
      mode: settings.darkMode ? 'dark' : 'light',
      primary: {
        main: '#6366F1',
        light: '#818CF8',
        dark: '#4F46E5',
        contrastText: '#ffffff',
      },
      secondary: {
        main: '#4F46E5',
        light: '#6366F1',
        dark: '#4338CA',
        contrastText: '#ffffff',
      },
      background: {
        default: settings.darkMode ? '#0F172A' : '#F8FAFC',
        paper: settings.darkMode ? '#1E293B' : '#FFFFFF',
      },
      text: {
        primary: settings.darkMode ? '#F1F5F9' : '#0F172A',
        secondary: settings.darkMode ? '#94A3B8' : '#475569',
      },
      warning: {
        main: '#FF6B00',
        light: '#FF9A3C',
        dark: '#F57C00',
        contrastText: '#ffffff',
      },
      error: {
        main: '#FF6B6B',
        light: '#FF8A8A',
        dark: '#FF000D',
        contrastText: '#ffffff',
      },
      success: {
        main: '#4CAF50',
        light: '#81C784',
        dark: '#2E7D32',
        contrastText: '#ffffff',
      },
      info: {
        main: '#6B73FF',
        light: '#8A91FF',
        dark: '#000DFF',
        contrastText: '#ffffff',
      },
    },
    shape: {
      borderRadius: 12,
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            borderRadius: 8,
            padding: '8px 16px',
          },
        },
      },
      MuiCard: {
        styleOverrides: {
          root: {
            borderRadius: 12,
            boxShadow: settings.darkMode 
              ? '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)'
              : '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
          },
        },
      },
    },
  });
}; 